import { bs2ad as e } from "../../../calendar-carburettor/converter/index.js";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_eng_day_info.ts
var t = e, n = (e, n, r) => {
	let i = t([
		e,
		n,
		r
	].join("-")).split("-");
	return {
		engYear: parseInt(i[0]),
		engMonth: parseInt(i[1]),
		engDay: parseInt(i[2])
	};
};
export { n as get_eng_day_info };

//# sourceMappingURL=get_eng_day_info.js.map